import { useEffect, useState } from 'react';

interface UseOrderIframeModalProps {
  orderId?: string;
  isSuccessfulOrder?: boolean;
  iframeUrl?: string;
  autoShow?: boolean;
}

export const useSpinTheWheelModal = ({
  orderId,
  isSuccessfulOrder = false,
  autoShow = true,
}: UseOrderIframeModalProps) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (autoShow && isSuccessfulOrder && orderId) {
      setShowModal(true);
    }
  }, [autoShow, isSuccessfulOrder, orderId]);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return {
    showModal,
    openModal,
    closeModal,
  };
};
